import { render, staticRenderFns } from "./AddFolder.vue?vue&type=template&id=2e927903&scoped=true&"
import script from "./AddFolder.vue?vue&type=script&lang=js&"
export * from "./AddFolder.vue?vue&type=script&lang=js&"
import style0 from "./AddFolder.vue?vue&type=style&index=0&id=2e927903&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e927903",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e927903')) {
      api.createRecord('2e927903', component.options)
    } else {
      api.reload('2e927903', component.options)
    }
    module.hot.accept("./AddFolder.vue?vue&type=template&id=2e927903&scoped=true&", function () {
      api.rerender('2e927903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/FinalDocuments/AddFolder.vue"
export default component.exports